import { ConfirmDialog } from "@bps/fluent-ui";
import { useStores } from "@stores/hooks/useStores.ts";

interface XeroRemoveOrganisationLinkDialogProps {
  onDismiss: () => void;
  showModal: boolean;
  tenantId: string;
  setError: (value: string) => void;
}

export const XeroRemoveOrganisationLinkDialog: React.FC<
  XeroRemoveOrganisationLinkDialogProps
> = ({ onDismiss, showModal, tenantId, setError }) => {
  const { customIntegrationXero, notification } = useStores();

  const DIALOG_TEXT =
    "Do you want to remove the Xero organisation link with Omni?";

  return (
    <ConfirmDialog
      hidden={!showModal}
      confirmButtonProps={{
        headers: "Remove organisation link",
        text: "Remove"
      }}
      maxWidth={470}
      styles={({ theme }) => ({
        root: {
          ".ms-Dialog-header": {
            height: 80
          },
          ".ms-Dialog-subText": { color: theme.palette.neutralPrimary }
        }
      })}
      cancelButtonProps={{ text: "Cancel" }}
      dialogContentProps={{
        title: "Remove organisation link",
        subText: DIALOG_TEXT
      }}
      onConfirm={async () => {
        try {
          await customIntegrationXero.deleteXeroConnectionTenant(tenantId);
          onDismiss();
        } catch (error) {
          setError(error.message);
          notification.error(error.message);
        }
      }}
      onCancel={onDismiss}
    />
  );
};
